<template>
  <div class="project-structure-element-propset ml-1">
    <div style="display: flex; cursor: pointer" @click="closed = !closed">
      <v-icon>{{ closed ? 'keyboard_arrow_right' : 'keyboard_arrow_down' }}</v-icon>
      <div>{{ prop_set.name }}</div>
    </div>
    
    <div class="font-weight-light ml-6" v-if="!closed">
      <ProjectStructureElementValue v-for="prop in getUObjects({ type: 'properties', ids: prop_set.properties })"
        :key="prop.id" :map_value="true" :value_is_number="!isNaN(parseFloat(prop.value))" :is_edit_mode="$store.state.ProjectStructure.ui_mode === 'edit'"
        @mapValue="$emit('mapValue', { attribute: $event.value, prop: prop })"
        >

        <div class="pb-2 w-100">
          <TText color="white" size="12" :value="prop.value" />
          <hr style="border-color:  #FFFFFF80;" >
          <div class="source-and-takeover-filter-field">
            <TTooltip
              v-if="showTakeoverFilter"
              value="Set to Filter (CTRL + click to add as new Filterline)"
              >
              <TIcon size="16" 
                  name="filter" style="cursor: pointer;"
                  @click.native.prevent.stop="$emit('takeoverFilter', { prop: prop, evt:$event})"
              />
            </TTooltip>
            <TText color="#FFFFFFB3" size="9" :value="prop.name" />
          </div>
        </div>
        
        <!-- {{ prop.name }}: {{ prop.value }} -->
      </ProjectStructureElementValue>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProjectStructureElementValue from '@/components/ProjectStructure/ProjectStructureElementValue.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import TTooltip from '@/components/Taktify/TTooltip.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';



export default {
  props: [
    'prop_set',
    'showTakeoverFilter'
  ],

  components: {
    ProjectStructureElementValue,
    TText,
    TTooltip,
    TIcon,
  },
  data: () => ({
    closed: true,
  }),
  computed: {
    ...mapGetters('Ultra', [
      'getUObjects',
    ]),
  }
}
</script>
<style>
.project-structure-element-propset {
  display: flex;
  flex-direction: column;
}

.w-100 {
  width: 100%;
  margin-right: 24px;
}

.source-and-takeover-filter-field {
  display: flex; 
  align-items: center; 
  grid-gap: 2px;
  padding-top: 2px;
}
</style>
  